<template>
  <!-- div class="grid">
    <div class="col-1">
      <div class="label-number">&nbsp;</div>
    </div>
    <div class="col-11">
      <div class="grid">
        <div class="col-12">
          <div class="paragraph title-margin" v-html="$tc('questionnaireForm.titleHumanITInfrastructure')"/>
        </div>
      </div>
    </div>
  </div -->

  <div class="m-0 h-full" style="justify-content: space-between">
    <div class="flex w-full h-full" style="position: relative">

      <div class="questionCount">
        <span>Question</span>
        <div style='font-weight: 700;'>
          <span id='currentQuestion'>{{ activeQuestion - 83 }}</span>
          <span style='font-weight: 400;'>/</span>
          <span id='allQuestions'>14</span>
        </div>
      </div>

      <Stepper linear unstyled: true v-model:active-step="activeSub">

        <StepperPanel :header="$tc('questionnaireForm.titleTechnologyManagement')">
          <QuestionRating v-if="activeQuestion == 84" question="84" :change="autoSave"></QuestionRating>
          <QuestionRating v-if="activeQuestion == 85" question="85" :change="autoSave"></QuestionRating>
          <QuestionRating v-if="activeQuestion == 86" question="86" :change="autoSave"></QuestionRating>
          <QuestionRating v-if="activeQuestion == 87" question="87" :change="autoSave"></QuestionRating>
          <QuestionRating v-if="activeQuestion == 88" question="88" :change="autoSave"></QuestionRating>
        </StepperPanel>

        <StepperPanel :header="$tc('questionnaireForm.titleManagementSkills')">
          <QuestionRating v-if="activeQuestion == 89" question="89" :change="autoSave"></QuestionRating>
          <QuestionRating v-if="activeQuestion == 90" question="90" :change="autoSave"></QuestionRating>
          <QuestionRating v-if="activeQuestion == 91" question="91" :change="autoSave"></QuestionRating>
          <QuestionRating v-if="activeQuestion == 92" question="92" :change="autoSave"></QuestionRating>
        </StepperPanel>

        <StepperPanel :header="$tc('questionnaireForm.titleTechnicalSkills')">
          <QuestionRating v-if="activeQuestion == 93" question="93" :change="autoSave"></QuestionRating>
          <QuestionRating v-if="activeQuestion == 94" question="94" :change="autoSave"></QuestionRating>
          <QuestionRating v-if="activeQuestion == 95" question="95" :change="autoSave"></QuestionRating>
          <QuestionRating v-if="activeQuestion == 96" question="96" :change="autoSave"></QuestionRating>
          <QuestionRating v-if="activeQuestion == 97" question="97" :change="autoSave"></QuestionRating>
        </StepperPanel>

      </Stepper>

    </div>
  </div>

</template>

<script lang="ts">
// @ is an alias to /src

import { Options, Vue } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import axios from 'axios';
import { User } from "@/data/User";
import { Application } from "@/data/Application";
import { AuthService } from "@/service/AuthService";
import { ref } from "vue";

import { defineComponent, PropType } from 'vue';
import QuestionRating from "@/components/questionnaire/QuestionRating.vue";

export default defineComponent({
  components: { QuestionRating },
  computed: {
    User() {
      return User
    },
    Application() {
      return Application
    }
  },
  props: {
    activeQuestion: {
      type: Number,
      required: true
    },
    activeSub: {
      type: Number,
      required: true
    }
  },
  methods: {
    autoSave: () => {
      User.get().invitation.response.save();
    }
  },
  setup() {
  },
})
</script>
<style>
.title-margin {
  margin-left: -30px;
}

.p-stepper .p-stepper-header.p-highlight .p-stepper-number {
  background: #0d3d52;
  color: #ffffff;
}

.stepper-offset-horizontal {
  margin-left: 78px;
}

.p-stepper {
  width: 99% !important;
}

.p-stepper-content {
  margin-left: -75px;
}

.p-slider-range {
  background-color: #5EBCB8;
}

.p-slider .p-slider-handle {
  background-color: #0d3d52;
  border-style: none;
}
</style>
